import { toast } from "react-toastify";


// Import the correct function to create signup data
import { CreateEmailSignup } from "./FormData"; 
import Urls from "../Urls";

const UploadRegistration = async (data) => {
  try {
    const response = await fetch(Urls.POSTEMAIL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email: data }),
    });

    const responseData = await response.json();

    if (response.ok) {
      toast.success("Email signup successful!", { position: "top-right", autoClose: 3000 });
      return responseData;
    } else {
      // Extract error messages dynamically
      if (responseData.email && Array.isArray(responseData.email)) {
        responseData.email.forEach((errorMsg) => {
          toast.error(errorMsg, { position: "top-right", autoClose: 3000 });
        });
      } else {
        toast.error(responseData.message || "Failed to sign up.", { position: "top-right", autoClose: 3000 });
      }
      throw new Error(responseData.message || "Failed to sign up.");
    }
  } catch (error) {
    toast.error(error.message || "An error occurred. Please try again later.", { position: "top-right", autoClose: 3000 });
  }
};

export { UploadRegistration };
